// src/com/auto_plan_upload/AutoPlanUploadRow.js
import React, { useMemo } from 'react';
// import { Box, fontWeight, padding, textAlign } from '@mui/system';
import { styled } from '@mui/material/styles';
// import { TableCell } from '@mui/material';
import { AppStyle, TopCode } from '../../value/AppConst';
import ValueMisc from '../../value/ValueMisc';

const LabelStyle={
    autoIRMiddleBlueBold : {
        color:'blue',
        fontWeight:'bold',
    },
    autoIRsmall : {
        fontSize:10
    },
    autoIRSmallBold :{
        fontSize:10,
        fontWeight:'bold'
    },
    autoIRMiddle: {
        fontSize:11
    },
    autoIRMiddleRedBold:{
        color: '#ff3600',
        fontWeight:'bold'
    },
    autoIRBig:{
        //fontSize:12
    },
    autoIRBigBold:{
        //fontSize:12,
        fontWeight:'bold'
    },
    autoIrPtYellow : {
        width:'100%',
        backgroundColor:'yellow',
        color:'red',
        //fontSize:12,
        fontWeight:'bold',
        borderRadius:5,
        paddingRight:5
    },
    autoIrPtRed:{
        width:'100%',
        backgroundColor:'red',
        color:'yellow',
        //fontSize:12,
        fontWeight:'bold',
        borderRadius:5,
        paddingRight:5
    },
    autoIrPtNormal:{
        width:'100%',
        //fontSize:12,
        fontWeight:'bold',
        color:'red',
        paddingRight:5
    },
    /*자동배차 호차 */
    autoHochaChangeGood: {
        width:'100%',
        backgroundColor: 'red', // borderRadius:3,
        paddingLeft:2, paddingRight:2,
        color:'white'
    },
    autoHochaNextDay:{
        width:'100%',
        backgroundColor: '#ffd38a', padding: '0 2px 0 2px'
    },
    autoHochaTransFragY:{
        width:'100%', border: '2px solid #2962a4', padding: '0 2px 0 2px'
    },
    autoNoneStyle:{
        width:'100%', padding: '0 2px 0 2px'
    },
    rowStyle1:{
        backgroundColor: '#FAF8F8'
    },
    rowStyle2:{
        backgroundColor: '#FFFFFF'
    },
    // new
    red: {color:'red'},
    blue: {color:'blue'},
};

const TableRow = styled('tr')({
    borderBottom: '1px solid #eee',
    padding: 0,
});

const LeftBold100 = {width:'100%', textAlign:'left',fontWeight:'bold'};
const CenterBold100 = {width:'100%', textAlign:'center',fontWeight:'bold'};

const ValueCell = styled('td')({
    padding: '2px 5px 2px 5px', fontSize: '0.75rem'
});

const CC = styled('div')({
    // Cell Content
    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    padding: 0
})

const Boxel = ({children, style, ccStyle}) => {
    return(
        <ValueCell style={style}>
            <CC style={ccStyle}>
                {children}
            </CC>
        </ValueCell>
    )
};

const Cell = styled('div')({
    padding:0
});

const hhmm = (h2m2) => {
    if(h2m2) {
        const t = h2m2.padStart(4, '0');
        return t.substr(0,2) + ':' + t.substr(2,2);
    }
    return '';
};

/**
 * 상온자동배차의 점포별 레코드를 출력. Table Row 하나.
 * @param {*} param0 
 * @returns 
 */
export default function AutoPlanUploadRow({
    item, // item이 null 이면 빈 행 출력.
}) {
    const resOverPtStyle = useMemo(()=>{
        if(item) {
            if(item.restOverPt >= 3) return LabelStyle.autoIrPtYellow;
            if(item.nextday04Pt + item.restOverPt <= -3) return LabelStyle.autoIrPtRed;
            return LabelStyle.autoIrPtNormal;
        }
        return null;
    }, [item]);

    const plans = useMemo(()=>{
        if(item) {
            const ten = Array(10).fill({});
            if(item.plans) {
                item.plans.forEach((plan)=>{
                    if(plan.planId && plan.hocha) {
                        const idx = plan.hocha-1;
                        if(idx<10) ten[idx] = plan;
                    }
                })
            }
            return ten;
        }
        return Array(2).fill({});
    }, [item]);

    const renderPlans = () => {
        return plans.map((plan, idx)=>{
            if(!plan) return <Boxel key={idx}></Boxel>;
            const planStyle = plan.tsrPrinted ? LabelStyle.autoHochaTransFragY : LabelStyle.autoNoneStyle;
            const typeStyle
            = ValueMisc.isAnsungOrHaman(plan.dcCd)
            ?
            (
                plan.vehPlates ? LabelStyle.autoNoneStyle : LabelStyle.autoHochaChangeGood
            )
            :
            plan.chargeGood ? LabelStyle.autoHochaChangeGood : LabelStyle.autoNoneStyle;

            return(
                <Boxel key={idx} ccStyle={planStyle}>
                    <div style={typeStyle}>
                        <Cell style={CenterBold100}>{plan.vehTypeAlias}</Cell>
                        <Cell style={LeftBold100}>
                            {plan.shprTime ? plan.shprTime.substring(0,5) : ''}
                        </Cell>
                    </div>
                    <div style={plan.nextDay ? LabelStyle.autoHochaNextDay : LabelStyle.autoNoneStyle}>
                        <Cell style={{width:'100%', textAlign:'center', color:"blue",fontWeight:'bold'}}>
                            {plan.startTime ? plan.startTime.substring(0,5) : ''}
                        </Cell>
                        <Cell style={{width:'100%', textAlign:'right', color:'red',fontWeight:'bold'}}>
                            {plan.arriveTime ? plan.arriveTime.substring(0,5) : ''}
                        </Cell>
                        <Cell style={LeftBold100}>
                            {plan.returnTime ? plan.returnTime.substring(0,5) : ''}
                        </Cell>
                    </div>
                </Boxel>
            )
        })
    };

    if(!item) {
        return(
            <TableRow>
                <ValueCell colSpan={26}>
                    <CC style={{color:'transparent'}}>
                        <Cell>|</Cell>
                        <Cell>|</Cell>
                        <Cell>|</Cell>
                        <Cell>|</Cell>
                        <Cell>|</Cell>
                    </CC>
                </ValueCell>
            </TableRow>
        );
    }

    return(
        <TableRow hover
            style={
                item.dcCd===TopCode.DcCode.Adc982 && TopCode.ADCStoresToStare.includes(item.storeId) ?
                {backgroundColor: '#fdff98'} : {}
            }
        >
            <Boxel>{item.basicDockno}</Boxel>
            <Boxel>
                <Cell style={
                    item.lastShipTime === '1600' ? LabelStyle.autoIRMiddleBlueBold : 
                    (
                        ((item.mainVehTypeName === 'T' || item.mainVehTypeName === 'D' || item.mainVehTypeName === 'T-') &&
                        (item.maxVehTypeName === 'T' || item.maxVehTypeName === 'D' || item.maxVehTypeName === 'T-')) ? 
                        LabelStyle.autoIRMiddleRedBold : LabelStyle.autoIRBigBold
                    )
                }>{item.storeName}</Cell>
                <Cell>{item.storeId}</Cell>
            </Boxel>
            <Boxel>
                <Cell><b>{hhmm(item.firstShipTime)}</b></Cell>
                <Cell><b style={LabelStyle.red}>{hhmm(item.lastShipTime)}</b></Cell>
                <Cell>
                    {item.mainVehTypeName}/{item.maxVehTypeName}
                </Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.red}>
                    {item.distanceOne}
                </Cell>
                <Cell>
                    {hhmm(item.basicExpectRunTime)}
                </Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.red}>
                    {item.leftOver || '-'}
                </Cell>
            </Boxel>
            <Boxel>
                {ValueMisc.float2str(item.totVol)}
            </Boxel>
            <Boxel>
                <Cell>{item.nBulkPt ? item.nBulkPt : '-'}</Cell>
                <Cell>{item.yBulkPt ? item.yBulkPt : '-'}</Cell>
                <Cell style={LabelStyle.blue}>{item.oBulkPt ? item.oBulkPt : '-'}</Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.blue}>{item.pbsPt15 || '-'}</Cell>
                <Cell style={{color:'red', fontSize:'0.6rem'}}>
                    {item.storeCpp || '-'}
                </Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.red}>{item.dayPt18 || '-'}</Cell>
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.red}>{item.dayPt04 || '-'}</Cell>
                <Cell style={LabelStyle.red}>{item.dayPt11 || '-'}</Cell>
                <Cell style={LabelStyle.red}>{item.dayPt15 || '-'}</Cell>
            </Boxel>
            <Boxel style={{borderLeft:AppStyle.BorderCCC}}>
                {
                    item.bindOne &&
                    <>
                    <Cell style={LabelStyle.blue}>{item.bindOne.targetStoreId}</Cell>
                    <Cell style={LabelStyle.blue}>{item.bindOne.targetHocha.toString().padStart(3,'0')}</Cell>
                    <Cell>&nbsp;</Cell>
                    <Cell style={LabelStyle.blue}>{item.bindOne.bindStoreId}</Cell>
                    <Cell style={LabelStyle.blue}>{item.bindOne.bindHocha.toString().padStart(3,'0')}</Cell>
                    </>
                }
            </Boxel>
            <Boxel style={{borderLeft:AppStyle.BorderCCC, borderRight:AppStyle.BorderCCC}}>
                {
                    item.bindTwo &&
                    <>
                    <Cell style={LabelStyle.blue}>{item.bindTwo.targetStoreId}</Cell>
                    <Cell style={LabelStyle.blue}>{item.bindTwo.targetHocha.toString().padStart(3,'0')}</Cell>
                    <Cell>&nbsp;</Cell>
                    <Cell style={LabelStyle.blue}>{item.bindTwo.bindStoreId}</Cell>
                    <Cell style={LabelStyle.blue}>{item.bindTwo.bindHocha.toString().padStart(3,'0')}</Cell>
                    </>
                }
            </Boxel>
            <Boxel>
                <Cell style={LabelStyle.autoIRBigBold}>{item.comName.substring(0,6)}</Cell>
                <Cell style={{fontSize:'0.6rem'}}>{item.loadMaxCnt || '-'}</Cell>
                <Cell style={LabelStyle.blue}>{item.didaNote}</Cell>
            </Boxel>
            <Boxel>
                <Cell style={{textAlign:'right', width: '60%'}}>
                    <Cell>{item.totalPt}</Cell>
                    <Cell style={resOverPtStyle}>{item.restOverPt}</Cell>
                    <Cell>{item.nextday04Pt}</Cell>
                </Cell>
            </Boxel>
            <Boxel>
                <Cell>차종</Cell>
                <Cell>접안</Cell>
                <Cell>출발</Cell>
                <Cell>도착</Cell>
                <Cell>복귀</Cell>
            </Boxel>
            {renderPlans()}
            <Boxel>
                {/* 노트가 없는디 */}
            </Boxel>
        </TableRow>
    );
}